export default __webpack_public_path__ + "static/10.03-8-09c29180e4aaebedaed63bc45286a812.png";